<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img v-if="avatar" :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <img v-else src="@/assets/du_logo.png" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link v-if="$store.state.user.homeAccess" to="/home">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="handleUpdate">个人中心</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="修改密码" :visible.sync="formVisible">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" show-password maxlength="64" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="头像" prop="headImg">
          <imageUpload v-model="form.headImg" width="32" height="32" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="saving" @click="formVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { getInfo, updateProfile } from '@/api/_user'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    password: '',
    headImg: null
  }
  return formBean
}
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ImageUpload
  },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      saving: false,
      formRules: {
        password: [{ required: true, whitespace: true, message: '请输入密码', trigger: 'blur' }],
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userId'
    ]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    handleUpdate() {
      this.form = initFormBean()
      getInfo(this.$store.state.user.token).then(({ code, data, message }) => {
        if (String(code) !== '0' || !data) {
          this.$message.error(message || '个人资料加载失败，请重试')
          return
        }
        this.form.headImg = data.headImg || null
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch(() => this.$message.error('个人资料加载失败，请重试'))
    },
    doCreate() {
      if (this.saving) return
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.saving = true
          const params = { password: this.form.password, headImg: this.form.headImg }
          updateProfile(params).then((data) => {
            this.postCallback(data)
            this.$store.commit('user/SET_AVATAR', params.headImg)
          }).catch(() => { /* 请求拦截器展示错误，保留表单供用户重试。 */ })
            .finally(() => { this.saving = false })
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  background-image: linear-gradient(to right, #e1edf3, #efe7ec, #f4f1eb);
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
